export default __webpack_public_path__ + "static/media/offers-top-banner.1421fc60.jpg";